"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrgMemberStruct = exports.ROLE_COUNTER = exports.ROLE_ADMIN = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.ROLE_ADMIN = 'admin';
exports.ROLE_COUNTER = 'counter';
exports.OrgMemberStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    email: (0, superstruct_1.string)(),
    name: (0, superstruct_1.optional)((0, superstruct_1.nullable)((0, superstruct_1.string)())),
    role: (0, superstruct_1.enums)([exports.ROLE_ADMIN, exports.ROLE_COUNTER]),
    createdAt: utils_1.TimestampStruct,
});
exports.OrgMemberStruct.type = 'OrgMember';
//# sourceMappingURL=orgMember.js.map